import { TSpeedLineItemWithDescription } from '@r1-frontend/ui-react/organisms/SpeedLine/SpeedLineWithDescription';
import { TArrayTwoOrMore } from '@r1-frontend/shared/types/Array';

import { ITariff } from '~/src/entities/formattedTariff';

export type TGetSpeedLineItemsReturnType = {
    bundles: TArrayTwoOrMore<TSpeedLineItemWithDescription>,
    internet: TArrayTwoOrMore<TSpeedLineItemWithDescription>,
} | null;

const getSpeedLineItems = (tariffs: ITariff[], isVillage: boolean): TGetSpeedLineItemsReturnType => {
    const preparedTariffs = tariffs
        .filter(
            (tariff: ITariff) => (
                tariff.availableOnInternetPage &&
                tariff.speed &&
                (isVillage ? tariff.isCottage : !tariff.isCottage)
            ),
        )
        .sort((a, b) => a.speed - b.speed);

    const { bundles, internet } = preparedTariffs
        .reduce<{ bundles: TSpeedLineItemWithDescription[], internet: TSpeedLineItemWithDescription[] }>((cur, acc) => {
            const simpleTariff = {
                id: acc.salePackageId,
                alias: String(acc.alias),
                title: String(acc.title),
                speed: acc.speed,
                descriptionList: acc.advantages?.map(adv => adv.description) || [],
                price: acc.priceAction ? acc.priceAction : acc.price,
            };

            if (acc.type === 'bundles') {
                cur.bundles.push(simpleTariff);
            }

            if (acc.type === 'internet') {
                cur.internet.push(simpleTariff);
            }
            return cur;
        }, {
            bundles: [],
            internet: [],
        });

    if (internet.length > 1 && bundles.length > 1) {
        return {
            bundles: [bundles[0], bundles[1], ...bundles.splice(2)],
            internet: [internet[0], internet[1], ...internet.splice(2)],
        };
    } else {
        return null;
    }
};

export default getSpeedLineItems;
